import { defineAction } from "rd-action-creators";
import { Tours } from "@common";

export const tourStartedAction = defineAction<TourStartedActionFields>("TOUR STARTED");

export interface TourStartedActionFields {
    tour: Tours;
}

export const restartGuideAction = defineAction("TOUR RESTARTED");
